// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"6bd95c51","149":"ba8c753e","189":"830629fb","424":"b841037b","490":"e26ed671","518":"7febad5e","667":"26a91a8e","781":"78a63678","872":"bcb716cc"}[chunkId] + ".chunk.js";
};